import { useParams } from 'react-router-dom';
import SubscriptionFormComponent from './SubscriptionForm';
import React from 'react';

export default function EditSubscription() {
  let { id } = useParams();
  return <SubscriptionFormComponent id={id} />;
}
